export const EthnicityEnum = {
  No_Response: 0,
  Hispanic_Or_Latino: 1,
  Not_Hispanic_Or_Latino: 2,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/EthnicityEnum.js